import { render, staticRenderFns } from "./MaleRecommends.vue?vue&type=template&id=575dfba1&scoped=true&"
import script from "./MaleRecommends.vue?vue&type=script&lang=js&"
export * from "./MaleRecommends.vue?vue&type=script&lang=js&"
import style0 from "./MaleRecommends.vue?vue&type=style&index=0&id=575dfba1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575dfba1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCol,VContainer,VRow})
